
// tslint:disable-next-line: class-name
export class subClip {
    public static classType = m4m["subClip"] = subClip;
    public name: string = "";
    public loop: boolean = false;
    public startframe: number = 0;
    public endframe: number = 0;
}
